export const ITEM_UNIT_MASTER_OBJECT_TYPE = 'ITEM_UNIT_MASTER';

export const ITEM_UNIT_MASTER_ACTION_MAP = {
    enable: 'enable',
    disable: 'disable',
};

export const ITEM_UNIT_PARAMS = 'item_unit_list';
